import { DeleteUser, User, UserPermissionModel, UserTypeRoles } from '@/types';
import {
  Core,
  RESET_PASSWORD,
  RESET_USER_PASSWORD,
  USER_LOGOUT,
  USER_PERMISSIONS,
  USER_TYPES,
  USERS,
} from '../Core';

class Users extends Core {
  getUserPermissions = async () =>
    this.get<UserPermissionModel>(USER_PERMISSIONS());

  getUsers = async (userId?: number) => this.get<User[]>(USERS(userId));

  getUserTypes = async () => this.get<UserTypeRoles[]>(USER_TYPES());

  createUser = async (data: User) => this.post(USERS(), data);

  updateUser = async (data: User) => this.patch(USERS(data.id), data);

  deleteUser = async (data: DeleteUser) => this.delete(USERS(), data);

  resetPassword = async (newPassword: string) =>
    this.post<string>(RESET_PASSWORD(), { newPassword });

  resetUserPassword = async (userId: number) =>
    this.post<string>(RESET_USER_PASSWORD(), { userId });

  logout = async () => this.post(USER_LOGOUT());
}

export const users = new Users();
